<template>
	<div>
		<p v-if="$tera.project.components">
			<span v-if="$tera.project.components.length">
				The following components were included in the search string:
				{{
					joinArrayWithAnd(
						formatSelectMulti($tera.project.components)
					).toLowerCase()
				}}
			</span>
			<span v-if="$tera.project.specialist.length">
				This search string was constructed by [a/an]
				{{
					joinArrayWithAnd(
						formatSelectMulti($tera.project.specialist)
					).toLowerCase()
				}}.
			</span>
			<span v-if="$tera.project.helper.length">
				[A/An]
				{{
					joinArrayWithAnd(formatSelectMulti($tera.project.helper)).toLowerCase()
				}}
				helped in the design of the search.
			</span>
			<span v-if="$tera.project.tools.length">
				<p>
					{{
						selectRandom([
							`We used ${joinArrayWithAnd(
								formatSelectMulti($tera.project.tools)
							)} to help design and run the
					search.`,
							`The following were used ${joinArrayWithAnd(
								formatSelectMulti($tera.project.tools)
							)} to help with the
					search.`
						])
					}}
				</p>
			</span>
			<span v-if="$tera.project.peerReviewer.length">
				The search strategy was peer-reviewed by [a/an]
				{{
					joinArrayWithAnd(
						formatSelectMulti($tera.project.peerReviewer)
					).toLowerCase()
				}}
				according to PRESS guidelines.
			</span>
		</p>

		<p>
			{{ ` Authors (${designSearchStrategyAuthorsInitials}) ` }}
			designed and ran the strategy.
		</p>

		<p
			v-if="
				!$tera.project.isRestrictedByPublicationType &&
					!$tera.project.isRestrictedByLanguage
			"
		>
			{{
				selectRandom([
					"No publication type or language restrictions were applied.",
					"We did not apply restrictions to publication type or language.",
					"All publication types and languages were included in the search."
				])
			}}
		</p>
		<p v-else>
			<span v-if="$tera.project.isRestrictedByPublicationType">
				Restrictions were applied to the publication types.
				{{
					capitalize(
						joinArrayWithAnd(
							formatSelectMulti($tera.project.excludedPublicationTypes)
						).toLowerCase()
					)
				}}
				were excluded from the search.
			</span>
			<span v-else>
				No publication type restrictions were applied.
			</span>
			<span v-if="$tera.project.isRestrictedByLanguage">
				We included studies in the following languages:
				{{
					joinArrayWithAnd(formatSelectMulti($tera.project.includedLanguages))
				}}.
			</span>
			<span v-else>
				No restrictions on language were applied.
			</span>
		</p>

		<p>
			{{ ` Authors (${deduplicateResultsAuthorsInitials}) ` }}
			deduplicated the results.
		</p>

		<p>
			{{ selectRandom(["We also ", "Additionaly, we"]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.supplementoryMethods)
				).toLowerCase()
			}}
		</p>
		<span v-if="$tera.project.databaseTools.length">
			<p>
				{{
					selectRandom([
						`We used ${joinArrayWithAnd(
							formatSelectMulti($tera.project.databaseTools)
						)} to help run the supplementary
				search.`,
						`The supplementary searches were done in
				${joinArrayWithAnd(formatSelectMulti($tera.project.databaseTools))}.`
					])
				}}
			</p>
		</span>
		<p>
			{{ ` Authors (${conductSSearchAuthorsInitials}) ` }}
			conducted the supplementary searches.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputSearchStrategy",
	mixins: [OutputMixin],
	computed: {
		designSearchStrategyAuthorsInitials: function() {
			return this.formatSelectMulti(this.$tera.project.searchStrategyAuthors)
				.map(el => this.nameToInitials(el))
				.join(", ");
		},
		deduplicateResultsAuthorsInitials: function() {
			return this.formatSelectMulti(this.$tera.project.searchStrategyAuthors)
				.map(el => this.nameToInitials(el))
				.join(", ");
		},
		conductSSearchAuthorsInitials: function() {
			return this.formatSelectMulti(this.$tera.project.conductSSearchAuthors)
				.map(el => this.nameToInitials(el))
				.join(", ");
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
